// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-articles-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
}

.modal-articles {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 1300px;
  /* Hauteur figee au max : le modal ne se redimensionne pas quand les articles arrivent,
     il est deja a sa taille max des l'ouverture. Le contenu (flex:1) scrolle a l'interieur. */
  height: 95vh;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* Mode INTEGRE (page /chiffrage) : meme catalogue, pose dans la page. On neutralise le seul habillage
   de modale — plus d'overlay fixe, plus de hauteur 95vh imposee, plus d'ombre portee. Le rendu
   interieur (recherche, lignes, details, grille de prix) reste strictement identique. */
.modal-articles-inline-root {
  width: 100%;
}

.modal-articles-inline-root .modal-articles {
  height: auto;
  max-height: none;
  box-shadow: none;
  border: 1px solid #E5E7EB;
  /* \`max-width: 1300px\` sert a centrer la modale dans le viewport : en page, il bride le catalogue,
     qui doit occuper toute la largeur disponible. */
  max-width: none;
}

/* Le contenu garde son propre defilement : la page ne doit pas s'allonger a l'infini. */
.modal-articles-inline-root .modal-articles-content {
  max-height: 60vh;
}

/* APERCU : resume du reste du catalogue. Valeurs reprises de l'ancien CataloguePreview, pour un rendu
   identique a ce qui existait. */
.modal-articles-preview-more {
  padding: 1.4rem 2rem;
  color: #f97316;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: center;
  background: #fff;
}

.modal-articles-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 1px solid #E5E7EB;
  background-color: #FAFAFA;
}

.modal-articles-header h2 {
  color: #2C3948;
  font-size: 2.4rem;
  margin: 0;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 2.4rem;
  cursor: pointer;
  color: #6B7280;
  padding: 0.5rem;
  border-radius: 4px;
  transition: all 0.3s ease;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background-color: #F3F4F6;
  color: #374151;
}

.modal-articles-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #E5E7EB;
  border-top: 4px solid #f97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.articles-list {
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.article-row {
  display: grid;
  grid-template-columns: 80px 1fr 190px 170px 100px;
  gap: 2rem;
  padding: 2rem;
  border-bottom: 1px solid #E5E7EB;
  align-items: center;
  transition: background-color 0.3s ease;
}

/* Page Catalogue (mode consultation) : ni quantite ni total -> 3 colonnes (code / info / details).
   La ligne entiere est cliquable (creation d'un bon de commande). */
.article-row--browse {
  grid-template-columns: 80px 1fr 100px;
}

.article-row--clickable {
  cursor: pointer;
}

.article-row:hover {
  background-color: #F9FAFB;
}

.article-row:nth-child(even) {
  background-color: #FAFAFA;
}

.article-row:nth-child(even):hover {
  background-color: #F3F4F6;
}

.article-code {
  font-weight: 600;
  color: #2C3948;
  font-size: 1.4rem;
  text-align: center;
}

.article-info {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.article-nom {
  color: #2C3948;
  font-size: 1.4rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
}

.article-prix {
  color: #6B7280;
  font-size: 1.2rem;
}

.prix-value {
  font-weight: 600;
  color: #2C3948;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 0;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
}

.quantity-btn {
  background-color: #F9FAFB;
  border: none;
  width: 3.6rem;
  height: 3.6rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
  font-weight: 600;
  color: #6B7280;
  transition: all 0.3s ease;
}

.quantity-btn:hover:not(:disabled) {
  background-color: #F3F4F6;
  color: #374151;
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-btn.decrease {
  border-right: 1px solid #E5E7EB;
}

.quantity-btn.increase {
  border-left: 1px solid #E5E7EB;
}

.quantity-input {
  border: none;
  width: 100%;
  min-width: 11rem;
  height: 3.6rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  color: #2C3948;
  background-color: white;
}

.quantity-input:focus {
  outline: none;
  background-color: #F9FAFB;
}

/* Masquer les flèches des inputs number */
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.quantity-input[type=number] {
  -moz-appearance: textfield;
}

.article-total {
  text-align: right;
  min-height: 2rem; /* CORRECTION: Garder une hauteur minimale même si vide */
}

.total-label {
  color: #6B7280;
  font-size: 1.1rem;
  margin-bottom: 0.2rem;
}

.total-value {
  color: #2C3948;
  font-size: 1.5rem;
  font-weight: 600;
  white-space: nowrap;
  min-height: 1.4rem; /* CORRECTION: Hauteur minimale pour éviter le décalage */
}

.modal-articles-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-top: 1px solid #E5E7EB;
  background-color: #FAFAFA;
}

.footer-summary {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.selected-count {
  color: #6B7280;
  font-size: 1.3rem;
}

.footer-total {
  color: #2C3948;
  font-size: 1.6rem;
  font-weight: 600;
}

.total-amount {
  color: #f97316;
}

.footer-actions {
  display: flex;
  gap: 1rem;
}

/* Page Catalogue (browse) : plus de total a gauche -> les actions (Annuler + creation BC/MS) s'alignent
   a droite. */
.modal-articles-footer--actions-only {
  justify-content: flex-end;
}

/* Aide de lecture des seuils remontee en haut de la modale (page Catalogue), sous la recherche. */
.modal-articles-grille-info {
  margin-top: 1.5rem;
}

/* NOUVEAUTÉ: Style pour les articles ajoutés à la commande (grisés) */
.article-row.article-added {
  background-color: #f8f9fa !important;
  color: #6c757d;
  border-left: 4px solid #f97316;
}

.article-row.article-added:hover {
  background-color: #e9ecef !important;
}

.article-row.article-added .article-nom {
  color: #6c757d;
}

.article-row.article-added .article-prix {
  color: #6c757d;
}

.article-row.article-added .prix-value {
  color: #6c757d;
}

/* Garder les contrôles de quantité actifs même sur les articles grisés */
.article-row.article-added .quantity-controls {
  opacity: 1;
}

.article-row.article-added .quantity-btn,
.article-row.article-added .quantity-input {
  opacity: 1;
}

/* Style pour le total quand l'article est ajouté */
.article-row.article-added .total-value {
  font-weight: 600;
}

.prix-placeholder {
  font-style: italic;
  color: #9CA3AF;
  font-size: 1.1rem;
}

/* État de sauvegarde */
.modal-articles.saving {
  pointer-events: none;
}

.modal-articles.saving .modal-articles-content {
  opacity: 0.7;
}

/* Styles pour les boutons pendant la sauvegarde */
.quantity-btn:disabled,
.quantity-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.close-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* NOUVEAU: Styles pour la barre de recherche */
.modal-articles-search {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #E5E7EB;
  background-color: #FAFAFA;
}

.search-info {
  margin-top: 1rem;
  color: #6B7280;
  font-size: 1.3rem;
  text-align: center;
}

.search-info span {
  font-weight: 500;
}

/* Assurer que la SearchBar prend toute la largeur */
.modal-articles-search .search-bar {
  width: 100%;
}

/* Rangee recherche + bouton "laisser le presta remplir" (contexte acheteur) : le bouton est colle a
   droite de l'input, centre verticalement, avec un gap de 1rem. La recherche prend le reste. */
.modal-articles-search-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  /* Le champ code de chiffrage (contexte BC acheteur) peut s'ajouter a la rangee : on autorise le retour
     a la ligne pour ne pas comprimer la recherche sur les largeurs etroites. Sans effet quand la rangee
     ne porte que la recherche (+ un bouton), qui tiennent deja sur une ligne. */
  flex-wrap: wrap;
}
.modal-articles-search-row .search-bar {
  flex: 1 1;
  width: auto;
}
.modal-articles-laisser-presta {
  flex-shrink: 0;
}

/* Champ "code de chiffrage" (contexte BC acheteur, opt-in) : saisie + bouton "Appliquer le code",
   cales a droite de la recherche dans la meme rangee (flex). L'eventuel message d'erreur metier
   s'affiche SOUS la rangee, pleine largeur (voir .modal-articles-code-error). */
.modal-articles-code {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-shrink: 0;
}

.modal-articles-code-input {
  height: 3.6rem;
  min-width: 18rem;
  padding: 0 1.2rem;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 1.4rem;
  color: #374151;
  background-color: white;
}

.modal-articles-code-input::placeholder {
  color: #9CA3AF;
}

.modal-articles-code-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-articles-code-btn {
  flex-shrink: 0;
}

.modal-articles-code-error {
  margin-top: 1rem;
}

/* Animation pour les résultats de recherche */
.articles-list {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Style pour l'état "Aucun résultat" */
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.error-state p {
  color: #6B7280;
  font-size: 1.6rem;
  margin-bottom: 2rem;
}

/* Améliorer l'accessibilité avec focus visible sur la recherche */
.modal-articles-search input:focus {
  outline: 2px solid #f97316;
  outline-offset: 2px;
}

/* Responsive */
@media (max-width: 1024px) {
  .article-row {
    grid-template-columns: 70px 1fr 100px 90px 80px;
    gap: 1rem;
    padding: 1.5rem;
  }

  .article-row--browse {
    grid-template-columns: 70px 1fr 80px;
  }

  .article-nom {
    font-size: 1.3rem;
  }

  .quantity-controls {
    transform: scale(0.9);
  }
}

@media (max-width: 768px) {
  .modal-articles-overlay {
    padding: 1rem;
  }

  .modal-articles {
    max-height: 95vh;
  }

  .article-row {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1.5rem;
    text-align: left;
  }

  .article-code {
    text-align: left;
    font-size: 1.2rem;
  }

  .quantity-controls {
    justify-self: start;
    transform: none;
  }

  .article-total {
    text-align: left;
  }

  .details-btn {
    justify-self: start;
    width: fit-content;
  }

  .modal-articles-footer {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .footer-actions {
    width: 100%;
  }

  .footer-actions button {
    flex: 1 1;
  }
}

@media (max-width: 480px) {
  .modal-articles-header {
    padding: 1.5rem;
  }

  .modal-articles-header h2 {
    font-size: 2rem;
  }

  .article-row {
    padding: 1rem;
  }

  .modal-articles-footer {
    padding: 1.5rem;
  }

  .prix-table th:first-child,
  .prix-table td:first-child {
    width: 120px;
    font-size: 1.1rem;
  }

  .article-details-expanded {
    padding: 1rem;
  }
}

/* Conteneur d'article avec détails */
.article-container {
  border-bottom: 1px solid #E5E7EB;
}

.article-container:last-child {
  border-bottom: none;
}

/* Section des détails expandable */
.article-details-expanded {
  padding: 2rem;
  background-color: #F8F9FA;
  border-top: 1px solid #E5E7EB;
  animation: slideDown 0.3s ease-out;
}

.details-header h5 {
  color: #f97316;
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.details-description {
  margin-bottom: 2rem;
}

.details-description p {
  color: #374151;
  font-size: 1.4rem;
  line-height: 1.6;
  margin: 0;
}

.prix-degressifs h6 {
  color: #2C3948;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.prix-table {
  overflow-x: auto;
}

.prix-table table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.prix-table th {
  background-color: #F3F4F6;
  color: #374151;
  font-weight: 600;
  padding: 1.2rem;
  text-align: center;
  border-bottom: 1px solid #E5E7EB;
  font-size: 1.3rem;
}

.prix-table th:first-child {
  text-align: left;
  width: 200px;
}

.prix-table td {
  padding: 1.2rem;
  border-bottom: 1px solid #E5E7EB;
  font-size: 1.3rem;
  text-align: center;
}

.prix-table td:first-child {
  text-align: left;
  font-weight: 500;
  color: #2C3948;
}

.prix-table tbody tr:hover {
  background-color: #F9FAFB;
}

.prix-table tbody tr:last-child td {
  border-bottom: none;
}

/* Rappel des bornes de tranche (unite + seuils), au-dessus de la grille tarifaire. */
.details-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  margin-bottom: 2rem;
}

.details-meta > div {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.details-meta-label {
  color: #6B7280;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.details-meta-value {
  color: #374151;
  font-size: 1.4rem;
  font-weight: 500;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Grille tarifaire : rangs (lignes) x tranches de quantite (colonnes).
   Bloc autonome : n'herite PAS de \`.prix-table\`, dont le style vise un tableau a
   deux colonnes. Colonne Rang ferree a gauche, colonnes de tranche centrees, chiffres
   a chasse fixe pour rester alignes d'un rang a l'autre.
   ───────────────────────────────────────────────────────────────────────────── */
.grille-prix__titre {
  color: #2C3948;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0 0 1rem;
}

/* Le cadre arrondi vit ici : \`overflow\` rogne les coins que \`border-collapse\`
   empeche le tableau de porter lui-meme, et absorbe un nom de titulaire trop large. */
.grille-prix__scroll {
  background-color: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  overflow-x: auto;
}

.grille-prix__table {
  border-collapse: collapse;
  width: 100%;
}

/* Les feuilles de style sont importees en side-effect, donc globales : \`App.css\` pose un
   \`td { border-bottom }\` nu et \`Operation.css\` un \`tr { border-bottom }\` nu. Les deux fuient
   jusqu'ici et doublaient la bordure basse de la derniere ligne (celle du cadre exterieur).
   On les neutralise ICI plutot qu'a la source, qui habille tous les autres tableaux de l'app.
   Les separateurs de ce tableau sont poses plus bas, explicitement. */
.grille-prix__table tr,
.grille-prix__table th,
.grille-prix__table td {
  border-bottom: none;
}

/* Ferrage a gauche par defaut (colonne Rang) ; les colonnes de tranche sont centrees
   sur toute leur hauteur, en-tete comme prix. */
.grille-prix__table th,
.grille-prix__table td {
  padding: 1.2rem 1.6rem;
  text-align: left;
  white-space: nowrap;
}

/* Les en-tetes de tranche portent desormais une phrase complete ("Prix par unite pour des unites
   inferieures au seuil A"...) : on les laisse revenir a la ligne dans une largeur bornee, sinon la
   colonne s'etirerait sur toute la phrase. Les prix, eux, restent en \`nowrap\`. */
.grille-prix__table thead th:not(.grille-prix__rang-th) {
  white-space: normal;
  width: 18rem;
}

/* Separateur vertical entre colonnes. Pose sur toutes les cellules sauf la derniere :
   le cadre exterieur est deja porte par \`.grille-prix__scroll\`. */
.grille-prix__table th:not(:last-child),
.grille-prix__table td:not(:last-child) {
  border-right: 1px solid #E5E7EB;
}

/* Selecteur qualifie par \`.grille-prix__table\` : sans lui, \`.grille-prix__prix\` (0,1,0) perdrait
   contre le \`text-align: left\` de \`.grille-prix__table td\` (0,1,1) ci-dessus. */
.grille-prix__table thead th:not(.grille-prix__rang-th),
.grille-prix__table .grille-prix__prix {
  text-align: center;
}

.grille-prix__table thead th {
  background-color: #F3F4F6;
  border-bottom: 1px solid #E5E7EB;
  color: #374151;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.35;
  vertical-align: middle;
}

.grille-prix__table tbody tr:not(:first-child) th,
.grille-prix__table tbody tr:not(:first-child) td {
  border-top: 1px solid #E5E7EB;
}

.grille-prix__table tbody tr:hover th,
.grille-prix__table tbody tr:hover td {
  background-color: #F9FAFB;
}

/* Colonne Rang : \`width: 1%\` + \`nowrap\` = shrink-to-fit. Le navigateur ne peut pas
   descendre sous la largeur intrinseque du contenu, la colonne epouse donc le nom du
   titulaire le plus long au lieu de le casser ; le reste va aux colonnes de prix. */
.grille-prix__rang-th,
.grille-prix__rang {
  width: 1%;
}

.grille-prix__rang {
  font-weight: 400;
  line-height: 1.4;
}

.grille-prix__rang-num {
  color: #2C3948;
  display: block;
  font-size: 1.3rem;
  font-weight: 600;
}

.grille-prix__rang-nom {
  color: #374151;
  display: block;
  font-size: 1.3rem;
  font-weight: 500;
}

.grille-prix__rang-siret {
  color: #6B7280;
  display: block;
  font-family: monospace;
  font-size: 1.2rem;
}

.grille-prix__prix {
  color: #374151;
  font-size: 1.4rem;
  font-variant-numeric: tabular-nums;
  min-width: 11rem;
}

/* T1 = le prix applique aux petites quantites : celui qu'on lit en premier, d'ou son poids. */
.grille-prix__prix--t1 {
  color: #2C3948;
  font-weight: 600;
}

.grille-prix__prix--t3 {
  color: #6B7280;
}

/* Banniere d'explication de la grille (cote acheteur), entre le titre et le tableau. */
.grille-prix__info {
  margin: 0 0 1.2rem;
}

/* Le mode "riche" du Banner empile l'icone AU-DESSUS du contenu (flex column). On veut plutot :
   titre a DROITE du "i", puis le corps qui repasse pleine largeur SOUS le "i". On flotte donc
   l'icone a gauche : le titre se cale a sa droite, et des que le texte depasse la hauteur de
   l'icone il reprend toute la largeur, sous elle. \`display: flow-root\` contient le float (remplace
   le flex). Selecteur \`.grille-prix__info.ui-banner--rich\` (0,2,0) pour battre \`.ui-banner--rich\`
   (0,1,0) sans toucher au composant partage. */
.grille-prix__info.ui-banner--rich {
  display: flow-root;
  margin: 1.5rem 0;
}

.grille-prix__info .ui-banner__icon {
  float: left;
  margin: 0.15rem 0.75rem 0 0;
}

/* \`.ui-banner__content\` est en \`display: flex\` : un tel bloc etablit un contexte de formatage qui
   EVITE le float (il se decalerait entierement a droite du "i"). On le repasse en flux normal pour
   que ses lignes s'enroulent autour de l'icone. Le titre redevient un bloc, avec l'interligne que
   la \`gap\` flex assurait auparavant. */
.grille-prix__info .ui-banner__content {
  display: block;
}

.grille-prix__info .ui-banner__title {
  display: block;
  margin-bottom: 0.4rem;
}

.grille-prix__info-p {
  font-size: 1.3rem;
  line-height: 1.55;
  margin: 0 0 0.8rem;
}

.grille-prix__info-p:last-child {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  /* En-tetes de tranche : largeur libre sur mobile, le tableau scrolle deja. */
  .grille-prix__table thead th:not(.grille-prix__rang-th) {
    width: auto;
  }

  .grille-prix__table th,
  .grille-prix__table td {
    padding: 1rem;
  }

  /* La colonne Rang garde son shrink-to-fit : le tableau scrolle plutot que de
     casser le nom du titulaire sur plusieurs lignes. */
  .grille-prix__prix {
    min-width: 9rem;
  }

  .details-meta {
    gap: 2rem;
  }
}

.loading-details {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #6B7280;
  font-style: italic;
}

/* Animation pour l'expansion */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 500px;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .prix-table {
    font-size: 1.2rem;
  }

  .prix-table th,
  .prix-table td {
    padding: 0.8rem;
  }

  .prix-table th:first-child,
  .prix-table td:first-child {
    width: 150px;
  }

  .article-details-expanded {
    padding: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/ModalArticles/ModalArticles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB;8FAC4F;EAC5F,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;wFAEwF;AACxF;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB;oDACkD;EAClD,eAAe;AACjB;;AAEA,wFAAwF;AACxF;EACE,gBAAgB;AAClB;;AAEA;iCACiC;AACjC;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;oEACoE;AACpE;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAE,yDAAyD;AAC/E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;cACc;AACd;EACE,yBAAyB;AAC3B;;AAEA,kGAAkG;AAClG;EACE,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,oCAAoC;EACpC,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA,kDAAkD;AAClD;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,WAAW;AACb;;AAEA;+FAC+F;AAC/F;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;gFAE8E;EAC9E,eAAe;AACjB;AACA;EACE,SAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;;gFAEgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,+CAA+C;IAC/C,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;kFAKkF;AAClF;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;sFACsF;AACtF;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;sEAIsE;AACtE;;;EAGE,mBAAmB;AACrB;;AAEA;gDACgD;AAChD;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;iFAEiF;AACjF;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;kEACkE;AAClE;;EAEE,+BAA+B;AACjC;;AAEA;gFACgF;AAChF;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;oFAEoF;AACpF;;EAEE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,8FAA8F;AAC9F;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,kBAAkB;AACpB;;AAEA;;;;;+CAK+C;AAC/C;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;;uCAGuC;AACvC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;;EAEA;uDACqD;EACrD;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".modal-articles-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 2rem;\n}\n\n.modal-articles {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 1300px;\n  /* Hauteur figee au max : le modal ne se redimensionne pas quand les articles arrivent,\n     il est deja a sa taille max des l'ouverture. Le contenu (flex:1) scrolle a l'interieur. */\n  height: 95vh;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n/* Mode INTEGRE (page /chiffrage) : meme catalogue, pose dans la page. On neutralise le seul habillage\n   de modale — plus d'overlay fixe, plus de hauteur 95vh imposee, plus d'ombre portee. Le rendu\n   interieur (recherche, lignes, details, grille de prix) reste strictement identique. */\n.modal-articles-inline-root {\n  width: 100%;\n}\n\n.modal-articles-inline-root .modal-articles {\n  height: auto;\n  max-height: none;\n  box-shadow: none;\n  border: 1px solid #E5E7EB;\n  /* `max-width: 1300px` sert a centrer la modale dans le viewport : en page, il bride le catalogue,\n     qui doit occuper toute la largeur disponible. */\n  max-width: none;\n}\n\n/* Le contenu garde son propre defilement : la page ne doit pas s'allonger a l'infini. */\n.modal-articles-inline-root .modal-articles-content {\n  max-height: 60vh;\n}\n\n/* APERCU : resume du reste du catalogue. Valeurs reprises de l'ancien CataloguePreview, pour un rendu\n   identique a ce qui existait. */\n.modal-articles-preview-more {\n  padding: 1.4rem 2rem;\n  color: #f97316;\n  font-size: 1.3rem;\n  font-weight: 500;\n  text-align: center;\n  background: #fff;\n}\n\n.modal-articles-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 1px solid #E5E7EB;\n  background-color: #FAFAFA;\n}\n\n.modal-articles-header h2 {\n  color: #2C3948;\n  font-size: 2.4rem;\n  margin: 0;\n  font-weight: 600;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 2.4rem;\n  cursor: pointer;\n  color: #6B7280;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-button:hover {\n  background-color: #F3F4F6;\n  color: #374151;\n}\n\n.modal-articles-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #E5E7EB;\n  border-top: 4px solid #f97316;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.articles-list {\n  display: flex;\n  flex-direction: column;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.article-row {\n  display: grid;\n  grid-template-columns: 80px 1fr 190px 170px 100px;\n  gap: 2rem;\n  padding: 2rem;\n  border-bottom: 1px solid #E5E7EB;\n  align-items: center;\n  transition: background-color 0.3s ease;\n}\n\n/* Page Catalogue (mode consultation) : ni quantite ni total -> 3 colonnes (code / info / details).\n   La ligne entiere est cliquable (creation d'un bon de commande). */\n.article-row--browse {\n  grid-template-columns: 80px 1fr 100px;\n}\n\n.article-row--clickable {\n  cursor: pointer;\n}\n\n.article-row:hover {\n  background-color: #F9FAFB;\n}\n\n.article-row:nth-child(even) {\n  background-color: #FAFAFA;\n}\n\n.article-row:nth-child(even):hover {\n  background-color: #F3F4F6;\n}\n\n.article-code {\n  font-weight: 600;\n  color: #2C3948;\n  font-size: 1.4rem;\n  text-align: center;\n}\n\n.article-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.article-nom {\n  color: #2C3948;\n  font-size: 1.4rem;\n  font-weight: 500;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.article-prix {\n  color: #6B7280;\n  font-size: 1.2rem;\n}\n\n.prix-value {\n  font-weight: 600;\n  color: #2C3948;\n}\n\n.quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: white;\n}\n\n.quantity-btn {\n  background-color: #F9FAFB;\n  border: none;\n  width: 3.6rem;\n  height: 3.6rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n  font-weight: 600;\n  color: #6B7280;\n  transition: all 0.3s ease;\n}\n\n.quantity-btn:hover:not(:disabled) {\n  background-color: #F3F4F6;\n  color: #374151;\n}\n\n.quantity-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quantity-btn.decrease {\n  border-right: 1px solid #E5E7EB;\n}\n\n.quantity-btn.increase {\n  border-left: 1px solid #E5E7EB;\n}\n\n.quantity-input {\n  border: none;\n  width: 100%;\n  min-width: 11rem;\n  height: 3.6rem;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #2C3948;\n  background-color: white;\n}\n\n.quantity-input:focus {\n  outline: none;\n  background-color: #F9FAFB;\n}\n\n/* Masquer les flèches des inputs number */\n.quantity-input::-webkit-outer-spin-button,\n.quantity-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.quantity-input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.article-total {\n  text-align: right;\n  min-height: 2rem; /* CORRECTION: Garder une hauteur minimale même si vide */\n}\n\n.total-label {\n  color: #6B7280;\n  font-size: 1.1rem;\n  margin-bottom: 0.2rem;\n}\n\n.total-value {\n  color: #2C3948;\n  font-size: 1.5rem;\n  font-weight: 600;\n  white-space: nowrap;\n  min-height: 1.4rem; /* CORRECTION: Hauteur minimale pour éviter le décalage */\n}\n\n.modal-articles-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-top: 1px solid #E5E7EB;\n  background-color: #FAFAFA;\n}\n\n.footer-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.selected-count {\n  color: #6B7280;\n  font-size: 1.3rem;\n}\n\n.footer-total {\n  color: #2C3948;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n.total-amount {\n  color: #f97316;\n}\n\n.footer-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n/* Page Catalogue (browse) : plus de total a gauche -> les actions (Annuler + creation BC/MS) s'alignent\n   a droite. */\n.modal-articles-footer--actions-only {\n  justify-content: flex-end;\n}\n\n/* Aide de lecture des seuils remontee en haut de la modale (page Catalogue), sous la recherche. */\n.modal-articles-grille-info {\n  margin-top: 1.5rem;\n}\n\n/* NOUVEAUTÉ: Style pour les articles ajoutés à la commande (grisés) */\n.article-row.article-added {\n  background-color: #f8f9fa !important;\n  color: #6c757d;\n  border-left: 4px solid #f97316;\n}\n\n.article-row.article-added:hover {\n  background-color: #e9ecef !important;\n}\n\n.article-row.article-added .article-nom {\n  color: #6c757d;\n}\n\n.article-row.article-added .article-prix {\n  color: #6c757d;\n}\n\n.article-row.article-added .prix-value {\n  color: #6c757d;\n}\n\n/* Garder les contrôles de quantité actifs même sur les articles grisés */\n.article-row.article-added .quantity-controls {\n  opacity: 1;\n}\n\n.article-row.article-added .quantity-btn,\n.article-row.article-added .quantity-input {\n  opacity: 1;\n}\n\n/* Style pour le total quand l'article est ajouté */\n.article-row.article-added .total-value {\n  font-weight: 600;\n}\n\n.prix-placeholder {\n  font-style: italic;\n  color: #9CA3AF;\n  font-size: 1.1rem;\n}\n\n/* État de sauvegarde */\n.modal-articles.saving {\n  pointer-events: none;\n}\n\n.modal-articles.saving .modal-articles-content {\n  opacity: 0.7;\n}\n\n/* Styles pour les boutons pendant la sauvegarde */\n.quantity-btn:disabled,\n.quantity-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.close-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* NOUVEAU: Styles pour la barre de recherche */\n.modal-articles-search {\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #E5E7EB;\n  background-color: #FAFAFA;\n}\n\n.search-info {\n  margin-top: 1rem;\n  color: #6B7280;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n.search-info span {\n  font-weight: 500;\n}\n\n/* Assurer que la SearchBar prend toute la largeur */\n.modal-articles-search .search-bar {\n  width: 100%;\n}\n\n/* Rangee recherche + bouton \"laisser le presta remplir\" (contexte acheteur) : le bouton est colle a\n   droite de l'input, centre verticalement, avec un gap de 1rem. La recherche prend le reste. */\n.modal-articles-search-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  /* Le champ code de chiffrage (contexte BC acheteur) peut s'ajouter a la rangee : on autorise le retour\n     a la ligne pour ne pas comprimer la recherche sur les largeurs etroites. Sans effet quand la rangee\n     ne porte que la recherche (+ un bouton), qui tiennent deja sur une ligne. */\n  flex-wrap: wrap;\n}\n.modal-articles-search-row .search-bar {\n  flex: 1;\n  width: auto;\n}\n.modal-articles-laisser-presta {\n  flex-shrink: 0;\n}\n\n/* Champ \"code de chiffrage\" (contexte BC acheteur, opt-in) : saisie + bouton \"Appliquer le code\",\n   cales a droite de la recherche dans la meme rangee (flex). L'eventuel message d'erreur metier\n   s'affiche SOUS la rangee, pleine largeur (voir .modal-articles-code-error). */\n.modal-articles-code {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  flex-shrink: 0;\n}\n\n.modal-articles-code-input {\n  height: 3.6rem;\n  min-width: 18rem;\n  padding: 0 1.2rem;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  font-size: 1.4rem;\n  color: #374151;\n  background-color: white;\n}\n\n.modal-articles-code-input::placeholder {\n  color: #9CA3AF;\n}\n\n.modal-articles-code-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modal-articles-code-btn {\n  flex-shrink: 0;\n}\n\n.modal-articles-code-error {\n  margin-top: 1rem;\n}\n\n/* Animation pour les résultats de recherche */\n.articles-list {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Style pour l'état \"Aucun résultat\" */\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.error-state p {\n  color: #6B7280;\n  font-size: 1.6rem;\n  margin-bottom: 2rem;\n}\n\n/* Améliorer l'accessibilité avec focus visible sur la recherche */\n.modal-articles-search input:focus {\n  outline: 2px solid #f97316;\n  outline-offset: 2px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .article-row {\n    grid-template-columns: 70px 1fr 100px 90px 80px;\n    gap: 1rem;\n    padding: 1.5rem;\n  }\n\n  .article-row--browse {\n    grid-template-columns: 70px 1fr 80px;\n  }\n\n  .article-nom {\n    font-size: 1.3rem;\n  }\n\n  .quantity-controls {\n    transform: scale(0.9);\n  }\n}\n\n@media (max-width: 768px) {\n  .modal-articles-overlay {\n    padding: 1rem;\n  }\n\n  .modal-articles {\n    max-height: 95vh;\n  }\n\n  .article-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 1.5rem;\n    text-align: left;\n  }\n\n  .article-code {\n    text-align: left;\n    font-size: 1.2rem;\n  }\n\n  .quantity-controls {\n    justify-self: start;\n    transform: none;\n  }\n\n  .article-total {\n    text-align: left;\n  }\n\n  .details-btn {\n    justify-self: start;\n    width: fit-content;\n  }\n\n  .modal-articles-footer {\n    flex-direction: column;\n    gap: 1.5rem;\n    text-align: center;\n  }\n\n  .footer-actions {\n    width: 100%;\n  }\n\n  .footer-actions button {\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-articles-header {\n    padding: 1.5rem;\n  }\n\n  .modal-articles-header h2 {\n    font-size: 2rem;\n  }\n\n  .article-row {\n    padding: 1rem;\n  }\n\n  .modal-articles-footer {\n    padding: 1.5rem;\n  }\n\n  .prix-table th:first-child,\n  .prix-table td:first-child {\n    width: 120px;\n    font-size: 1.1rem;\n  }\n\n  .article-details-expanded {\n    padding: 1rem;\n  }\n}\n\n/* Conteneur d'article avec détails */\n.article-container {\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.article-container:last-child {\n  border-bottom: none;\n}\n\n/* Section des détails expandable */\n.article-details-expanded {\n  padding: 2rem;\n  background-color: #F8F9FA;\n  border-top: 1px solid #E5E7EB;\n  animation: slideDown 0.3s ease-out;\n}\n\n.details-header h5 {\n  color: #f97316;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.details-description {\n  margin-bottom: 2rem;\n}\n\n.details-description p {\n  color: #374151;\n  font-size: 1.4rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.prix-degressifs h6 {\n  color: #2C3948;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.prix-table {\n  overflow-x: auto;\n}\n\n.prix-table table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.prix-table th {\n  background-color: #F3F4F6;\n  color: #374151;\n  font-weight: 600;\n  padding: 1.2rem;\n  text-align: center;\n  border-bottom: 1px solid #E5E7EB;\n  font-size: 1.3rem;\n}\n\n.prix-table th:first-child {\n  text-align: left;\n  width: 200px;\n}\n\n.prix-table td {\n  padding: 1.2rem;\n  border-bottom: 1px solid #E5E7EB;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n.prix-table td:first-child {\n  text-align: left;\n  font-weight: 500;\n  color: #2C3948;\n}\n\n.prix-table tbody tr:hover {\n  background-color: #F9FAFB;\n}\n\n.prix-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Rappel des bornes de tranche (unite + seuils), au-dessus de la grille tarifaire. */\n.details-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3rem;\n  margin-bottom: 2rem;\n}\n\n.details-meta > div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.details-meta-label {\n  color: #6B7280;\n  font-size: 1.2rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.details-meta-value {\n  color: #374151;\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Grille tarifaire : rangs (lignes) x tranches de quantite (colonnes).\n   Bloc autonome : n'herite PAS de `.prix-table`, dont le style vise un tableau a\n   deux colonnes. Colonne Rang ferree a gauche, colonnes de tranche centrees, chiffres\n   a chasse fixe pour rester alignes d'un rang a l'autre.\n   ───────────────────────────────────────────────────────────────────────────── */\n.grille-prix__titre {\n  color: #2C3948;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin: 0 0 1rem;\n}\n\n/* Le cadre arrondi vit ici : `overflow` rogne les coins que `border-collapse`\n   empeche le tableau de porter lui-meme, et absorbe un nom de titulaire trop large. */\n.grille-prix__scroll {\n  background-color: white;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.grille-prix__table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n/* Les feuilles de style sont importees en side-effect, donc globales : `App.css` pose un\n   `td { border-bottom }` nu et `Operation.css` un `tr { border-bottom }` nu. Les deux fuient\n   jusqu'ici et doublaient la bordure basse de la derniere ligne (celle du cadre exterieur).\n   On les neutralise ICI plutot qu'a la source, qui habille tous les autres tableaux de l'app.\n   Les separateurs de ce tableau sont poses plus bas, explicitement. */\n.grille-prix__table tr,\n.grille-prix__table th,\n.grille-prix__table td {\n  border-bottom: none;\n}\n\n/* Ferrage a gauche par defaut (colonne Rang) ; les colonnes de tranche sont centrees\n   sur toute leur hauteur, en-tete comme prix. */\n.grille-prix__table th,\n.grille-prix__table td {\n  padding: 1.2rem 1.6rem;\n  text-align: left;\n  white-space: nowrap;\n}\n\n/* Les en-tetes de tranche portent desormais une phrase complete (\"Prix par unite pour des unites\n   inferieures au seuil A\"...) : on les laisse revenir a la ligne dans une largeur bornee, sinon la\n   colonne s'etirerait sur toute la phrase. Les prix, eux, restent en `nowrap`. */\n.grille-prix__table thead th:not(.grille-prix__rang-th) {\n  white-space: normal;\n  width: 18rem;\n}\n\n/* Separateur vertical entre colonnes. Pose sur toutes les cellules sauf la derniere :\n   le cadre exterieur est deja porte par `.grille-prix__scroll`. */\n.grille-prix__table th:not(:last-child),\n.grille-prix__table td:not(:last-child) {\n  border-right: 1px solid #E5E7EB;\n}\n\n/* Selecteur qualifie par `.grille-prix__table` : sans lui, `.grille-prix__prix` (0,1,0) perdrait\n   contre le `text-align: left` de `.grille-prix__table td` (0,1,1) ci-dessus. */\n.grille-prix__table thead th:not(.grille-prix__rang-th),\n.grille-prix__table .grille-prix__prix {\n  text-align: center;\n}\n\n.grille-prix__table thead th {\n  background-color: #F3F4F6;\n  border-bottom: 1px solid #E5E7EB;\n  color: #374151;\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.35;\n  vertical-align: middle;\n}\n\n.grille-prix__table tbody tr:not(:first-child) th,\n.grille-prix__table tbody tr:not(:first-child) td {\n  border-top: 1px solid #E5E7EB;\n}\n\n.grille-prix__table tbody tr:hover th,\n.grille-prix__table tbody tr:hover td {\n  background-color: #F9FAFB;\n}\n\n/* Colonne Rang : `width: 1%` + `nowrap` = shrink-to-fit. Le navigateur ne peut pas\n   descendre sous la largeur intrinseque du contenu, la colonne epouse donc le nom du\n   titulaire le plus long au lieu de le casser ; le reste va aux colonnes de prix. */\n.grille-prix__rang-th,\n.grille-prix__rang {\n  width: 1%;\n}\n\n.grille-prix__rang {\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.grille-prix__rang-num {\n  color: #2C3948;\n  display: block;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.grille-prix__rang-nom {\n  color: #374151;\n  display: block;\n  font-size: 1.3rem;\n  font-weight: 500;\n}\n\n.grille-prix__rang-siret {\n  color: #6B7280;\n  display: block;\n  font-family: monospace;\n  font-size: 1.2rem;\n}\n\n.grille-prix__prix {\n  color: #374151;\n  font-size: 1.4rem;\n  font-variant-numeric: tabular-nums;\n  min-width: 11rem;\n}\n\n/* T1 = le prix applique aux petites quantites : celui qu'on lit en premier, d'ou son poids. */\n.grille-prix__prix--t1 {\n  color: #2C3948;\n  font-weight: 600;\n}\n\n.grille-prix__prix--t3 {\n  color: #6B7280;\n}\n\n/* Banniere d'explication de la grille (cote acheteur), entre le titre et le tableau. */\n.grille-prix__info {\n  margin: 0 0 1.2rem;\n}\n\n/* Le mode \"riche\" du Banner empile l'icone AU-DESSUS du contenu (flex column). On veut plutot :\n   titre a DROITE du \"i\", puis le corps qui repasse pleine largeur SOUS le \"i\". On flotte donc\n   l'icone a gauche : le titre se cale a sa droite, et des que le texte depasse la hauteur de\n   l'icone il reprend toute la largeur, sous elle. `display: flow-root` contient le float (remplace\n   le flex). Selecteur `.grille-prix__info.ui-banner--rich` (0,2,0) pour battre `.ui-banner--rich`\n   (0,1,0) sans toucher au composant partage. */\n.grille-prix__info.ui-banner--rich {\n  display: flow-root;\n  margin: 1.5rem 0;\n}\n\n.grille-prix__info .ui-banner__icon {\n  float: left;\n  margin: 0.15rem 0.75rem 0 0;\n}\n\n/* `.ui-banner__content` est en `display: flex` : un tel bloc etablit un contexte de formatage qui\n   EVITE le float (il se decalerait entierement a droite du \"i\"). On le repasse en flux normal pour\n   que ses lignes s'enroulent autour de l'icone. Le titre redevient un bloc, avec l'interligne que\n   la `gap` flex assurait auparavant. */\n.grille-prix__info .ui-banner__content {\n  display: block;\n}\n\n.grille-prix__info .ui-banner__title {\n  display: block;\n  margin-bottom: 0.4rem;\n}\n\n.grille-prix__info-p {\n  font-size: 1.3rem;\n  line-height: 1.55;\n  margin: 0 0 0.8rem;\n}\n\n.grille-prix__info-p:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  /* En-tetes de tranche : largeur libre sur mobile, le tableau scrolle deja. */\n  .grille-prix__table thead th:not(.grille-prix__rang-th) {\n    width: auto;\n  }\n\n  .grille-prix__table th,\n  .grille-prix__table td {\n    padding: 1rem;\n  }\n\n  /* La colonne Rang garde son shrink-to-fit : le tableau scrolle plutot que de\n     casser le nom du titulaire sur plusieurs lignes. */\n  .grille-prix__prix {\n    min-width: 9rem;\n  }\n\n  .details-meta {\n    gap: 2rem;\n  }\n}\n\n.loading-details {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  color: #6B7280;\n  font-style: italic;\n}\n\n/* Animation pour l'expansion */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 500px;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .prix-table {\n    font-size: 1.2rem;\n  }\n\n  .prix-table th,\n  .prix-table td {\n    padding: 0.8rem;\n  }\n\n  .prix-table th:first-child,\n  .prix-table td:first-child {\n    width: 150px;\n  }\n\n  .article-details-expanded {\n    padding: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
